<template>
  <header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header">
        <a class="navbar-brand" v-if="isWhiteLabel">
          <!-- Logo icon -->
          <b>
            <span class="show-when-menu-collapsed logo-collapsed">CP</span>
            <span class="show-when-menu-expanded logo-expanded">Client</span>
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span class="show-when-menu-expanded logo-text">Portal</span>
        </a>
        <a class="navbar-brand" v-else>
          <!-- Logo icon -->
          <b>
            <span class="show-when-menu-collapsed logo-collapsed">NL</span>
            <span class="show-when-menu-expanded logo-expanded">Next</span>
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span class="show-when-menu-expanded logo-text">Lead</span>
        </a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse">
        <!-- ============================================================== -->
        <!-- toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav mt-md-0 ">
          <!-- This is  -->
          <li class="nav-item">
            <a @click.prevent="toggleMenu()" class="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark">
              <i class="mdi" :class="[isMenuMinimized ? 'mdi-menu' : 'mdi-arrow-left']"></i>
            </a>
          </li>
          <li class="nav-item">
            <a @click.prevent="toggleMenu()" class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" >
              <i class="icon-arrow-left-circle mdi" :class="[isMenuMinimized ? 'mdi-menu' : 'mdi-arrow-left']"></i>
            </a>
          </li>
        </ul>
        <span class="navbar-brand mb-0 h2 mr-auto text-muted">
          <span class="pr-3">{{title}} </span>
          <span v-if="isUserClient && getCompany.overdue" class="label label-rounded label-danger">Overdue</span>
        </span>
        <!--<div class="navbar-brand text-muted mb-0">-->
          <!--<span>Balance: </span>-->
          <!--<span v-for="(balance, index) in balances" :key="balances.currencyId">-->
              <!--<span :class="{ 'text-danger': balance.balance < 0 }">{{balance | currency}}</span>-->
              <!--<span v-if="balances.length > index+1">, </span>-->
            <!--</span>-->
        <!--</div>-->
        <ul class="navbar-nav my-lg-0">
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <img src="../assets/images/users/user.png" alt="user" class="profile-pic" />
              <span class="text-muted waves-effect waves-dark">{{name}}</span>
            </template>
            <b-dropdown-header>
              <h4>{{name}}</h4>
              <p class="text-muted">{{user.email}}</p>
            </b-dropdown-header>
            <b-dropdown-divider v-if="companyId && !isWhiteLabel"></b-dropdown-divider>
            <b-dropdown-item v-if="companyId && !isWhiteLabel" :to="{ name: 'EditCompany', params: { id: companyId }, query: { tab: 'detail' }}"><i class="mdi mdi-city"></i>  Company Settings</b-dropdown-item>
            <b-dropdown-item v-if="companyId && !isWhiteLabel" :to="{ name: 'EditCompany', params: { id: companyId }, query: { tab: 'billing' }}"><i class="mdi mdi-credit-card"></i>  Billing & Payments</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click.prevent="logout"><i class="mdi mdi-power"></i>  Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'navigation',

  computed: {
    ...mapState(['isMenuMinimized']),
    ...mapGetters(['getCompany', 'isUserClient', 'getCompanyBalances', 'isWhiteLabel']),
    user() {
      return this.$store.getters.getAuthUser;
    },
    photo() {
      if (this.user && this.user.photo) {
        return JSON.parse(this.user.photo);
      }
    },
    name() {
      if (this.user) {
        return this.user.name;
      }
    },
    companyId() {
      const {
        companyId,
        role: { role_type: roleType },
      } = this.user;

      return (companyId && roleType === 'client') ? companyId : undefined
    },
    title() {
      return (this.isUserClient && this.getCompany.companyName) ? this.getCompany.companyName : 'Admin Panel'
    },
    balances() {
      return this.getCompanyBalances;
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    },
    ...mapActions(['toggleMenu']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mini-sidebar .show-when-menu-expanded {
  display: none;
}
.mini-sidebar .show-when-menu-collapsed {
  display: inline-block;
}
.show-when-menu-expanded {
  display: inline-block;
}
.show-when-menu-collapsed {
  display: none;
}

@media (max-width: 768px) {
  .navbar-header {
    width: 60px;

    .logo-text {
      display: none !important;
    }
    .logo-expanded {
      display: none !important;
    }
    .logo-collapsed {
      display: inline-block !important;
    }
  }
}
.topbar .navbar-header {
  box-shadow: 4px -4px 10px rgba(0, 0, 0, 1);
  height: 70px;
}

</style>




// WEBPACK FOOTER //
// src/components/Navigation.vue